import { render, staticRenderFns } from "./UsersTableComponent.vue?vue&type=template&id=06321663"
import script from "./UsersTableComponent.vue?vue&type=script&lang=js"
export * from "./UsersTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports